import { Contract } from "appworks/utils/contracts/contract";
import { AnimateSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";

export class AgsAnimateBehaviour extends AnimateSymbolBehaviour {

    public anticipateLand(): Contract<void> {
        return this.animate("_land", ["land"], true);
    }

    public win(): Contract<void> {
        return this.animate("_win", [this.defaultAnimation], false, true);
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}
